/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import TableItems from "./TableItems";
import Om3pModal from "../OM3PComponents/Om3pModal";
import ModalDialog from "../../../../widgets/ModalDialog/ModalDialogLink";
import {PERMISSIONS} from '../../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../../_helpers/UserPermissionSingleton';

class InnerQuoteList extends React.Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.resourceIns !== this.props.resourceIns || nextProps.resourceUploadData !== this.props.resourceUploadData) {
            return true;
        }
        return false;
    }

    render() {
        const { resourceIns } = this.props;
        const arrayLength = resourceIns.length;
        return resourceIns.map((resourceIn, index) => (
            <Draggable key={resourceIn.resourceInstanceId} draggableId={resourceIn.resourceInstanceId} index={index} isDragDisabled= {UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_draggable)} >
                {(dragProvided, dragSnapshot) => (
                    <TableItems
                        deleteInstance = {this.props.deleteInstance}
                        title={this.props.title}
                        index={index}
                        key={resourceIn.resourceInstanceId}
                        resourceIn={resourceIn}
                        isDragging={dragSnapshot.isDragging}
                        provided={dragProvided}
                        createPart={this.props.createPart}
                        chapterId={this.props.chapterId}
                        collectionId={this.props.collectionId}
                        freezeUi={this.props.freezeUi}
                        length={arrayLength}
                        activeCollection={this.props.activeCollection}
                        getResource={this.props.getResource}
                        closeModal={this.props.closeModal}
                        resourceUploadData={this.props.resourceUploadData}
                        clearResource={this.props.clearResource}
                        resourceUploadSuccessDataEdit={this.props.resourceUploadSuccessDataEdit}
                        updateAdditionalResourceInfo={this.props.updateAdditionalResourceInfo}
                        clearAdditionalInfo={this.props.clearAdditionalInfo}
                    />
                )}
            </Draggable>
        ));
    }
}

class InnerList extends React.Component {
    render() {
        const { deleteInstance, resourceIns, dropProvided , title , createPart, chapterId, collectionId, freezeUi,
            activeCollection, resourceUploadData, getResource, closeModal, clearResource,resourceUploadSuccessDataEdit,
            updateAdditionalResourceInfo,clearAdditionalInfo}  = this.props;
        return (
            <div>
                <div ref={dropProvided.innerRef}>
                    <InnerQuoteList
                        deleteInstance = {deleteInstance}
                        resourceIns={resourceIns}
                        title = {title}
                        createPart = {createPart}
                        chapterId = {chapterId}
                        collectionId = {collectionId}
                        freezeUi={freezeUi}
                        activeCollection={activeCollection}
                        getResource={getResource}
                        closeModal={closeModal}
                        resourceUploadData={resourceUploadData}
                        clearResource={clearResource}
                        resourceUploadSuccessDataEdit={resourceUploadSuccessDataEdit}
                        clearAdditionalInfo={clearAdditionalInfo}
                        updateAdditionalResourceInfo={updateAdditionalResourceInfo}
                    />
                    {dropProvided.placeholder}
                </div>
            </div>
        );
    }
}

export default class TableBody extends React.Component {

    render() {
        const {
            deleteInstance,
            ignoreContainerClipping,
            isDropDisabled,
            listId,
            listType,
            style,
            resourceIns,
            createPart,
            chapterId,
            collectionId,
            freezeUi,
            activeCollection,
            uploadFile,
            resourceUploadData,
            updateAdditionalResourceInfo,
            resourceUploadSuccessDataEdit,
            clearAdditionalInfo,
            closeModal,
            getResource,
            clearResource
        } = this.props;
        return (
            <Droppable
                droppableId={listId}
                type={listType}
                ignoreContainerClipping={ignoreContainerClipping}
                isDropDisabled={isDropDisabled}
            >
                {(dropProvided) => (
                    <div
                        style={style}
                        {...dropProvided.droppableProps}
                    >
                        <div >
                            <InnerList
                                deleteInstance={deleteInstance}
                                resourceIns={resourceIns}
                                title={listId}
                                dropProvided={dropProvided}
                                createPart={createPart}
                                chapterId={chapterId}
                                collectionId={collectionId}
                                freezeUi={freezeUi}
                                activeCollection={activeCollection}
                                getResource={getResource}
                                closeModal={closeModal}
                                resourceUploadData={resourceUploadData}
                                clearResource={clearResource}
                                resourceUploadSuccessDataEdit={resourceUploadSuccessDataEdit}
                                updateAdditionalResourceInfo={updateAdditionalResourceInfo}
                                clearAdditionalInfo={clearAdditionalInfo}
                            />
                        </div>
                        <div className='ancorDiv'>
                            {!UserPermissionSingleton.hasPermission(PERMISSIONS.hide_add_content) && <a className="ancorStyle" onClick={()=>{this.props.showAddContentComponent(chapterId,resourceIns); } }> + Add Content </a>}
                            {!UserPermissionSingleton.hasPermission(PERMISSIONS.hide_add_om) && <ModalDialog
                                trigger={ <a className="ancorStyle" onClick={()=>{this.props.uploadContent(chapterId);}}> + Add OM </a>}
                                title="Add Original Material">
                                <Om3pModal activeCollection={activeCollection}
                                    uploadFile={uploadFile}
                                    resourceUploadData={resourceUploadData}
                                    updateAdditionalResourceInfo={updateAdditionalResourceInfo}
                                    resourceUploadSuccessDataEdit={resourceUploadSuccessDataEdit}
                                    clearAdditionalInfo={clearAdditionalInfo}
                                    clearResource={clearResource}
                                    closeModal={closeModal}/>
                            </ModalDialog>}
                        </div>
                    </div>

                )}
            </Droppable>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/TableBody.js